import { styled } from "@mui/material";
import React from "react";
import { ChatMessageRootProps } from "./ChatMessage.type";

export const ChatMessageRoot = styled("div", {
    slot: "message",
    label: "ChatMessage",
    name: "Chat",
})<ChatMessageRootProps>`
    &.FacChatMessage-root {
        display: flex;
        gap: 8px;
    }

    &.FacStandardChatMessage-root {
        display: flex;
        gap: 8px;
    }
    &.FacHeaderedChatMessage-root {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
`;

export const ChatMessageHeader: React.FC<
    React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
    >
> = styled("div")`
    &.FacChatMessage-header {
        margin: auto;
    }
    &.FacRightChatMessage-header {
        order: 2;
    }
    &.FacHeaderedChatMessage-header {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        padding-bottom: 4px;
        
        p {
            font-weight: bold;
        }
    }
`;

export const ChatMessageContentContainer = styled("div")`
    &.FacChatMessage-container {
        animation: 1.5s fade-in;

        @keyframes fade-in {
            from { opacity: 0 }
            to { opacity: 1 }
        }
    }
    &.FacStandardChatMessage-container {
        background-color: ${({ theme }) => theme.palette.primary.main};
        max-width: 70%;
        color: white;

        &.FacLeftChatMessage-container {
            padding: 6px 24px 12px 12px;
            border-radius: 4px 12px 12px 12px;
        }
        &.FacRightChatMessage-container {
            padding: 6px 24px 12px 12px;
            border-radius: 12px 4px 12px 12px;
        }
    }
`;

export const ChatMessageContentWrapper: React.FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = styled("div")`
    &.FacChatMessage-wrapper {
        width: 100%;
        display: flex;
        word-wrap: break-word;
        white-space: pre-wrap;
    }

    &.FacRightChatMessage-wrapper {
        justify-content: flex-end;
    }
`;

export default ChatMessageRoot;
